import { useEffect, useState } from 'react';

import Communicator from '../helpers/communication-adapter';
import { CommunicationMessageTypes } from '../helpers/constants';

export default function useCommunicator<T>(
  messageType: CommunicationMessageTypes
): Communicator<T> | undefined {
  const [communicator, setCommunicator] = useState<Communicator<T> | undefined>(
    undefined
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (Communicator.isReady) {
        console.log('CMA everything ready will create communicator');
        const _communicator = new Communicator<T>(messageType);
        setCommunicator(_communicator);
        clearInterval(interval);
      }
    }, 500);

    return () => {
      communicator?.close();
    };
  }, []);
  return communicator;
}
